<template>
  <div id="login_div">
    <v-container fluid>
      <v-row :align="alignment" :justify="justify">
      <v-col cols="12">
        <p class="text-center">
          <img src="@/assets/logo_infilesign_white.png" alt="Prisma Sign">
        </p>
      </v-col>

        <v-col cols="12" md="6">
          <v-alert
            v-if="!es_valido"
            border="top"
            colored-border
            type="error"
            class="text-center"
            elevation="2"
          >
            <p>El código QR utilizado para la toma de las fotografías no es valida, favor volver intentar con otro código. <br/><strong>{{mensaje_error}}</strong>.</p>
          </v-alert>
          <v-alert
            border="top"
            colored-border
            type="warning"
            elevation="2"
          >
            El video no debe durar más de 15 segundos
          </v-alert>
          <v-card class="elevation-12" v-if="es_valido">
            <v-card-title>
              <span style="text-align: center !important; display: block; width: 100%">Toma de fotografías</span>
            </v-card-title>
            <v-card-text>
                <input 
                  class="mb-0 pb-0" 
                  style="height: 0px; color: #fff; background: #fff; visibility: hidden;" 
                  type="file" 
                  accept="image/*" 
                  capture="camera" 
                  id="tomaRostro" 
                  v-on:change="tomaRostro" 
                />
                <v-btn
                  rounded 
                  block
                  color="#28b68f"
                  class="mb-3"
                  @click="openCamaraRostro"
                >
                  Fotografía de su rostro
                </v-btn>
                <p class="mb-0 text-center">
                  <img :src="foto_rostro" />
                </p>
                <input 
                  class="mb-0 pb-0" 
                  style="height: 0px; color: #fff; background: #fff; visibility: hidden;" 
                  type="file" 
                  accept="image/*" 
                  capture="camera" 
                  id="dpiReverso" 
                  v-on:change="dpiReverso" />
                <v-btn
                  rounded 
                  block
                  color="#28b68f"
                  class="mb-3"
                  @click="openCamaraDpiReverso"
                >
                  Fotografía DPI lado reverso
                </v-btn>
                <p class="mb-0 text-center">
                  <img :src="foto_dpi_reverso" />
                </p>
                <input 
                  style="height: 0px; color: #fff; background: #fff; visibility: hidden;" 
                  type="file" 
                  accept="image/*" 
                  capture="camera" 
                  id="dpiAnverso"
                  v-on:change="dpiAnverso" />
                <v-btn
                  rounded 
                  block
                  color="#28b68f"
                  class="mb-3"
                  @click="openCamaraDpiAnverso"
                >
                  Fotografía DPI lado anverso
                </v-btn>
                <p class="mb-0 text-center">
                  <img :src="foto_dpi_anverso" />
                </p>
                <v-form 
                  ref="form" 
                  enctype="multipart/form-data"
                  v-model="valid" 
                  lazy-validation>
                  <input type="file" 
                    style="height: 0px; color: #fff; background: #fff; visibility: hidden;" 
                    accept="video/*" 
                    capture="camera" 
                    id="tomaVideo"
                    v-on:change="tomaVideo" />
                    <v-btn
                      rounded 
                      block
                      color="#28b68f"
                      class="mb-3"
                      @click="openCamaraVideo"
                    >
                      Grabar video
                    </v-btn>
                </v-form>              
                <template v-if="toma_video !=''">
                  <video controls style="max-width: 100%">
                    <source :type="type_video" :src="toma_video">
                  </video>
                </template>
            </v-card-text>
            <v-card-actions>
              <!--<v-btn text :to="{name: 'login'}" class="mr-4" color="info">Iniciar sesión</v-btn> -->
              <v-btn text @click="borrarDatos" class="mr-4" color="info">Limpiar campos</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>        
      </v-row>
    </v-container>
  </div>
</template>
<script>
    import axios from "axios";       
    export default {  
    data: function() {
      return {
        valid: false,
        justify: 'center',
        alignment: 'center',
        es_valido: false,
        foto_rostro: '',
        foto_dpi_anverso: '',
        foto_dpi_reverso: '',
        toma_video: '',
        type_video: null,
        mensaje_error:'',
      };
    },
    computed: {
  
    },
    created() {
      this.validarCodigo();
    },
    mounted() {
      console.log("Qr.vue");
    },
    methods: {
      validarCodigo() {
        let getValidar = axios.get('QR/validar_qr?parametros='+ this.$route.query.parametros);
        return getValidar.then((callback) =>
        {
          console.log(callback.status)
          if(callback.status == 200) {
            this.es_valido = true;
          }
        }).catch((error) => {
            this.es_valido = false;
            console.log(error.response);
            this.mensaje_error = error.response.data;
        });
      },
      openCamaraRostro() {
        $("#tomaRostro").click();
      },
      openCamaraDpiReverso() {
        $("#dpiReverso").click();
      },
      openCamaraDpiAnverso(){
        $("#dpiAnverso").click();
      },
      openCamaraVideo() {
        $("#tomaVideo").click();
      },
      tomaRostro(e) {
        let _this = this;
        console.log(e);
        let fileReader = new FileReader();
        let file = e.target.files[0];
        fileReader.readAsDataURL(file);
        fileReader.onload = e => {
          _this.foto_rostro = e.target.result;
          _this.enviarImage("fotoRostro", _this.foto_rostro, file.type);
        }
      },
      dpiReverso(e) {
        let _this = this;
        console.log(e);
        let fileReader = new FileReader();
        let file = e.target.files[0];
        fileReader.readAsDataURL(file);
        fileReader.onload = e => {
          _this.foto_dpi_reverso = e.target.result;
          _this.enviarImage("fotoDpiReverso", _this.foto_dpi_reverso, file.type);
        }
      },
      dpiAnverso(e) {
        let _this = this;
        console.log(e);
        let fileReader = new FileReader();
        let file = e.target.files[0];
        fileReader.readAsDataURL(file);
        fileReader.onload = e => {
          _this.foto_dpi_anverso = e.target.result;
          _this.enviarImage("fotoDpiAnverso", _this.foto_dpi_anverso, file.type);
        }
      },
      tomaVideo(e) {
        let _this = this;
        _this.toma_video = '';
        let fileReader = new FileReader();
        let file = e.target.files[0];
        _this.type_video = file.type;
        fileReader.readAsDataURL(file);
        fileReader.onload = e => {
          _this.toma_video = e.target.result;       
          _this.enviarVideo("video", file, file.type);
        }
      },
      enviarImage(tipo, base64_image, extension) {
        let vdata = {
          "tipo": tipo,
          "extension": extension,
          "valor": base64_image,
          "llave":this.$route.query.parametros,
        }
        let vpost = axios.post('QR/enviar', vdata);
        return vpost.then((callback) =>
        { 
          console.log(callback.status)
          if(callback.status == 200) {
            console.log("enviado");
          }
        }).catch((error) => {
            console.log(error);
        });
      },
      enviarVideo(tipo, source, extension) {
        const formData = new FormData();
        formData.append('valor', "");
        formData.append('tipo', tipo);
        formData.append('video', source);
        formData.append('extension', extension);
        formData.append('llave', this.$route.query.parametros);

        let vpost = axios.post('QR/video', formData, { 'timeout': 900000 });
        return vpost.then((callback) =>
        { 
          console.log(callback.status)
          if(callback.status == 200) {
            console.log("enviado");
          }
        }).catch((error) => {
          alert(JSON.stringify(error));
          alert(JSON.stringify(error.response));
        });
      },
      borrarDatos() {
        this.foto_rostro = '';
        this.foto_dpi_anverso = '';
        this.foto_dpi_reverso = '';
        this.toma_video = '';
        this.type_video = '';
      }
    },
  };
</script>